<template>
  <Modal title="展位信息" class="component-business-shape-attribute" v-model="visible" :closable="false" :mask-closable="false">
    <el-form :rules="rules" :model="formData" ref="formData" label-width="80px">
      <el-row class="tr mb5">
        <el-col :span="16">
          <el-form-item label="展位编号" prop="code">
            <el-input style='width: 105%;' size="small" v-model="formData.codeBody"></el-input>
          </el-form-item>
        </el-col>
         <el-col :span="7">
          <el-form-item>
            <el-input style='margin-left: -100% ;width: 200%;' size="small" v-model="formData.codeIndex" @blur="checkValidateCode"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="1">&nbsp;</el-col>
      </el-row>
      <el-row class="tr mb5">
        <el-col :span="8">
          <el-form-item label="编号式样">
            <el-select style='width: 150%;' size="small" v-model="formData.codeFontFamily">
              <el-option v-for="item in baseFontOptions.fontFamily" :label="item.name" :value="item.value" :key="item.value">{{item.name}}</el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item>
            <el-select style='margin-left: -40% ;width: 155%;' size="small" v-model="formData.codeFontSize">
              <el-option v-for="item in baseFontOptions.fontSize"  :value="item" :key="item">{{item}}px</el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item>
            <el-select style='margin-left: -100% ;width: 200%;' size="small" v-model="formData.codeFontStyle">
              <el-option v-for="item in baseFontOptions.fontStyle" :label="item.name" :value="item.value" :key="item.value">{{item.name}}</el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="1">&nbsp;</el-col>
      </el-row>
      <el-row class="tr mb5">
        <el-col :span="23">
          <el-form-item label="展位名称">
            <el-input size="small" v-model="formData.name" :disabled='zwmcdisabled'></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="1">&nbsp;</el-col>
      </el-row>

      <el-row class="tr mb5">
        <el-col :span="8">
          <el-form-item label="名称式样">
            <el-select style='width: 150%;' size="small" v-model="formData.nameFontFamily">
              <el-option v-for="item in baseFontOptions.fontFamily" :label="item.name" :value="item.value" :key="item.value">{{item.name}}</el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item>
            <el-select style='margin-left: -40% ;width: 155%;' size="small" v-model="formData.nameFontSize">
              <el-option v-for="item in baseFontOptions.fontSize" :value="item" :key="item">{{item}}px</el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item>
            <el-select style='margin-left: -100% ;width: 200%;' size="small" v-model="formData.nameFontStyle">
              <el-option v-for="item in baseFontOptions.fontStyle" :label="item.name" :value="item.value" :key="item.value">{{item.name}}</el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="1">&nbsp;</el-col>
      </el-row>
      <el-row class="tr mb5">
        <el-col :span="11">
          <el-form-item label="展位类型"  prop="boothType">
            <el-select size="small" v-model="formData.boothType">
              <el-option value="标准展位">标准展位</el-option>
              <el-option value="光地">光地</el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="1">&nbsp;</el-col>
        <el-col :span="11">
          <el-form-item label="出口类型"  prop="entryType">
            <el-select size="small" v-model="formData.entryType">
              <el-option value="一面开">一面开</el-option>
              <el-option value="两面开">两面开</el-option>
              <el-option value="三面开">三面开</el-option>
              <el-option value="全开">全开</el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="1">&nbsp;</el-col>
      </el-row>

      <el-row class="tr mb5" v-if="formData.boothType=='标准展位'">
        <el-col :span="11">
          <el-form-item label="上展位号"  prop="top">
            <el-input size="small" v-model="formData.top"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="1">&nbsp;</el-col>
        <el-col :span="11">
          <el-form-item label="下展位号"  prop="bottom">
            <el-input size="small" v-model="formData.bottom"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="1">&nbsp;</el-col>
      </el-row>
      <el-row class="tr mb5" v-if="formData.boothType=='标准展位'">
        <el-col :span="11">
          <el-form-item label="左展位号"  prop="left">
            <el-input size="small" v-model="formData.left"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="1">&nbsp;</el-col>
        <el-col :span="11">
          <el-form-item label="右展位号"  prop="right">
            <el-input size="small" v-model="formData.right"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="1">&nbsp;</el-col>
      </el-row>
      <el-row class="tr mb5" v-if="formData.boothType=='标准展位'">
        <el-col :span="23">
          <el-form-item label="是否为3-4个标位特定选择区域" label-width="220px" prop="isSpecial" style="float:left">
            <el-radio-group v-model="formData.isSpecial">
              <el-radio label="0">否</el-radio>
              <el-radio label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="1">&nbsp;</el-col>
      </el-row>

      <el-row class="tr mb5">
        <el-col :span="11">
          <el-form-item label="横向长度"  prop="lateralLength">
            <el-input-number :min="0" v-model="formData.lateralLength" size="small" :formatter="value => `${value} 米`"
              :parser="value => value.replace(' 米', '')">
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="1">&nbsp;</el-col>
        <el-col :span="11">
          <el-form-item label="纵向长度"  prop="verticalLength">
            <el-input-number :min="0" v-model="formData.verticalLength" size="small" :formatter="value => `${value} 米`"
              :parser="value => value.replace(' 米', '')">
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="1">&nbsp;</el-col>
      </el-row>
      <el-row class="tr mb5">
        <el-col :span="23">
          <el-form-item label="展位面积">
            <el-input-number :min="0" v-model="formData.area" :disabled="true" :formatter="value => `${value} 平方米`" size="small" :parser="value => value.replace(' 平方米', '')">
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="1">&nbsp;</el-col>
      </el-row>
      <!--add by yushch 20250315 让综合馆选择展位展品类型-->
      <el-row class="tr mb" v-if="zgzplx =='99'">
        <el-col :span="23" >
          <el-form-item label="展品类型" prop="czlx">
            <el-select class="zwztcss"  size="small" v-model="formData.czlx">
              <el-option v-for="item in dataCzlx" :value="item.codeValue" :label="item.codeName" :key="item.codeValue">{{item.codeName}}</el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="1">&nbsp;</el-col>
      </el-row>
   

      <el-row class="tr mb" v-show="zwztdisabled == 1">
        <el-col :span="23" >
          <el-form-item label="展位状态">
            <el-select class="zwztcss"  size="small" @change="changeZwzt" v-model="formData.status">
              <el-option v-for="item in dataStatus" :value="item.value" :label="item.name" :disabled="item.disabled" :key="item.value">{{item.name}}</el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="1">&nbsp;</el-col>
      </el-row>
    </el-form>
    <div slot="footer" style="text-align: center;">
      <el-button type="clear" size="small" icon="el-icon-close" @click="$emit('close')">取消</el-button>
      <el-button type="success" size="small" icon="el-icon-check" @click="saveData('formData')">保存</el-button>
    </div>
  </Modal>
</template>
<script>
  import fontOptions from '@/store/static/plot/AppPlotBaseFontOptions'
  import emptyData from './emptyData.json'
  export default {
    props: {
      show: {
        type: Boolean,
        default: false
      },
      data: {
        type: Object
      },
      shapeWrapData: {
        type: Object
      }
    },
    data() {
      var validateCode = (rule, value, callback) => {
        if (this.formData.codeBody != '') {
          const me = this;
          // if(!this.formData.codeIndex){
          //   this.formData.codeIndex = '01'
          // }
          var params = {
            uuid: this.formData.uuid,
            zwh: this.formData.codeBody
          };
          if(this.formData.codeIndex){
            params.zwh = this.formData.codeBody+'-'+ this.formData.codeIndex;
          }
          me.$axios.post("/zwjbxx/isExistZwh",params).then(
            function(res) {
              if(res.data.result){
                callback(new Error("展位编号重复"));
              }else{
                callback();
              }
            }.bind(this),
            function(error) {
              console.log(error);
            }
          );
        } else {
          callback(new Error("请输入展位编号"));
        }
      };
      var checkLL = (rule, value, callback) => {
        if (this.formData.lateralLength == 0) {
          callback(new Error("横线长度必须大于0"));
        } else {
          callback();
        }
      };
      var checkVL = (rule, value, callback) => {
        if (this.formData.verticalLength == 0) {
          callback(new Error("横线长度必须大于0"));
        } else {
          callback();
        }
      };

      return {
        zwmcdisabled: true, //展位名称
        zwztdisabled: 1, //展位状态-预约展位
        visible: this.show,
        formData: emptyData,
        baseFontOptions: fontOptions,
        dataStatus: [],
        dataCzlx:[
          {
            codeName: "车辆及大型装备类",
            codeValue: "01"
          },
          {
            codeName: "装备器材类（含消防装备、综合应急类、社会服务机构及媒体）",
            codeValue: "02"
          }
        ],
        rules: {
          code: [{
            trigger: "blur",
            required: true,
            validator: validateCode
          }],
          boothType: [{
            trigger: "change",
            message: "请选择展位类型",
            required: true
          }],
          entryType: [{
            trigger: "change",
            message: "请选择出口类型",
            required: true
          }],
          lateralLength: [{
            trigger: "change",
            message: "请输入横向长度",
            required: true,
            validator: checkLL
          }],
          verticalLength: [{
            trigger: "change",
            message: "请输入纵向长度",
            required: true,
            validator: checkVL
          }],
          isSpecial: [{
            trigger: "change",
            message: "请选择",
            required: true
          }],
          czlx: [{
            trigger: "change",
            message: "请选择展品类型",
            required: true
          }],
        },
        zgzplx: '',//展馆的参展类型
      }
    },
    computed: {
    },
    watch: {
      show(newValue, oldValue) {
        this.visible = newValue
      },
      data(newValue, oldValue) {
        if(newValue.status == 'function'){
          this.zwmcdisabled = false
        }else{
          this.zwmcdisabled = true
        }
        this.formData = newValue
        if(this.formData.code){
          this.zwztdisabled = 0
        }else{
          this.zwztdisabled = 1
        }
        if(this.formData.stageUuid != ""){
          //add by yushch 20250315 根据展馆id 查询展馆的展品类型
          this.getCzlxByZgid();
          //end
        }
      },
      'formData.lateralLength': 'calcArea',
      'formData.verticalLength': 'calcArea'
    },
    created(){
      //获取展位状态
      this.getZwzt();
    },
    methods: {
      //根据uuid 查询展馆信息
      getCzlxByZgid: function(){
        let vm = this;
        vm.$axios.get('/zgjbxx/'+this.formData.stageUuid).then(function (res) {
          if(res.data.code == "00000000") {
            vm.zgzplx = res.data.result.reserve3;
          } 
        }.bind(this), function (error) {
          console.log(error);
        })

      },
      //获取展位状态
      getZwzt: function () {
            let vm = this;
            vm.$axios.get('/codelist/getCodetype/ZWZT').then(function (res) {
              if(res){
                var result = res.data.result;
                for(var i in result){
                  var ds = {}
                  var data = result[i]
                  ds.name = data.codeName
                  ds.value = data.codeValue
                  if(data.remark != 'DESIGN_DISABLE'){
                    vm.dataStatus.push(ds)
                  }
                }
              }
          }.bind(this), function (error) {
              console.log(error);
          })
      },
      changeZwzt(val){
        if(val == 'function'){
          this.zwmcdisabled = false
          this.formData.tenantId = ''
          this.formData.tenantName = ''
          this.formData.name = ''
        }else{
          this.zwmcdisabled = true
        }
      },
      handlerCancel() {
        this.formData = emptyData
        this.$emit('close')
      },
      saveData(formData) {
        this.$refs[formData].validate(valid => {
          if (valid) {
            this.$store.dispatch('updateBusinessRecord', this.formData)
            let shapeGroups = this.shapeWrapData.find('.shapeGroup')
            shapeGroups.forEach((item) => {
                if (item.getDraggable()) {
                    item.setDraggable(false)
                }
            })
            const shapeWrapObj = {
              shapeUuid: this.formData.shapeUuid,
              jsonData: JSON.stringify(this.shapeWrapData.toObject())
            }
            window.wrapHandshake.$emit('evtStageElementSave', {
              shape: shapeWrapObj,
              business: this.formData
            })
            this.$emit('close')
          }
        })

      },
      calcArea() {
        this.formData.area = this.formData.lateralLength * this.formData.verticalLength.toFixed(2)

        // if(this.formData.nameFontSize ==10){
        //   var _nameFontSize = this.formData.nameFontSize
        //   if(this.formData.area<=9){
        //     _nameFontSize = 8
        //   }
        // }
      },

      
      //序号blur，触发code的rules add by yushch 20230218
      checkValidateCode(){
        this.$refs['formData'].validateField('code');
      }
    }
  }
</script>

<style lang="scss" scoped>
  .component-business-shape-attribute {
    .ivu-input-number {
      display: block;
      width: auto;
    }
  }
  .zwztcss{
    width: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/ploter/businessShape/attribute.vue